import { Box, Button } from '@mui/material';
import { useTracking } from '../tracking';

export interface StepActionsProps {
  activeStep: number;
  numberOfSteps: number;
  disableNext?: boolean;
  handleStep: (step: number) => void;
}

const StepActions = ({
  activeStep,
  disableNext = false,
  handleStep,
}: StepActionsProps) => {
  const tracking = useTracking();
  const { generateTrackingProps } = tracking || {};
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        padding: '16px 0 8px',
        '& .step-action-button': {
          minWidth: '85px',
        },
      }}
    >
      <Button
        className="step-action-button"
        onClick={() => handleStep(activeStep - 1)}
        disabled={activeStep === 0}
        {...generateTrackingProps('previous-button')}
      >
        Previous
      </Button>
      <Button
        className="step-action-button"
        onClick={() => handleStep(activeStep + 1)}
        disabled={disableNext}
        variant="outlined"
        {...generateTrackingProps('next-button')}
      >
        Next
      </Button>
    </Box>
  );
};

export default StepActions;
